<div [ngClass]="component.ratio || ''"
     class="overflow-hidden">
    <href class="fill"
          ngSkipHydration
          [link]="component.link">
        <!-- image -->
        @if (component.background_image) {
        <div class="fill z-1">
            <df-image-wrapper>
                <img [ratio]="component.ratio"
                     [dfImage]="component.background_image">
            </df-image-wrapper>
        </div>
        }
        @if (component.video_id && !component.video_hide) {
        @if (component.video_provider === 'youtube') {
        <youtube-player class="z-1"
                        [class.fill]="!!component.ratio"
                        [video-id]="component.video_id"
                        [autoplay-in-viewport]="component.video_autoplay"
                        [background]="component.video_background">
        </youtube-player>
        }
        @if (component.video_provider === 'vimeo') {
        <vimeo-player class="z-1"
                      [class.fill]="!!component.ratio"
                      [video-id]="component.video_id"
                      [autoplay-in-viewport]="component.video_autoplay"
                      [background]="component.video_background">
        </vimeo-player>
        }
        }
        @if (component.blocks && component.blocks.length) {
        <div class="fill z-3 flex">
            <div class="flex"
                 [ngClass]="[((component.width) ? component.width : 'w-12')]">
                <div class="w-12 pos-relative">
                    <!-- blocks -->

                    @for (block of component.blocks; track $index; let i = $index) {
                    @switch (block.custom) {
                    @case (false) {
                    <text-overlay [data]="block"></text-overlay>
                    }
                    @case (true) {
                    <div class="pos-absolute right-0"
                         [ngClass]="['z-' + i, block.style || '', (block.custom ? 'left-0' : '')]"
                         [style.top.%]="(block.top_position || 0)"
                         [style.left.%]="(block.custom ? 0 : block.left_position || 0)">
                        <icms-outlet [components]=" block.components">
                        </icms-outlet>
                    </div>
                    }
                    }
                    }
                </div>
            </div>
        </div>
        }
        <shop-this-look [content]="component"
                        [bigSpace]="true"></shop-this-look>
    </href>
</div>
